
<!-- 登陆后进入的主页 -->
<!-- 显示所有课程列表-->
<template>
  <div>
    <!-- 加载动画-->
    <div v-if="isLoading">
      <div style="width: 100%;height: 100%;position: relative;top: 50%;">
        <img src="../assets/loading2.gif" width="50%" >
      </div>
    </div>

    <Header></Header>

    <div class="box">
      <div @click="logout">
        <img src="../assets/exit.png" style="  position: fixed;left: 0px;top: 40px;width: 80px;height:80px;z-index:9999;display: none;" id="musicPlayIco">
        <img src="../assets/exit-2.jpg" class="turn" style="  position: fixed;left: 0px;top: 0px;width: 80px;height:80px;:9999; " id="musicStopIco">
      </div>

      <!-- 刷新按钮-->
      <div @click="refreshPages">
        <img src="../assets/refresh-2.jpg" class="turn" style="  position: fixed;right: 0px;top: 0px;width: 80px;z-index:9999;border-radius:100px; " id="musicStopIco">
      </div>

      <div v-for="(course ,index) in courseList">
        <div class="imgCard" @click="toCourse(index,course.id,course.course_num)" >
          <img :src="course.course_cover_image"   class="courseImg">
        </div>
      </div>
    </div>

    <!-- 显示没有订单的提手信息 需要满足两点 1。订单长度等于0 2。在我的课程这一项下-->
    <div v-if="isOrder&&isMyOrder">
<!--      <NoOrder></NoOrder>-->
      <img src="../assets/noOrder.png" width="70%">
    </div>
    <div style="width: 100%;height: 50px;"></div>

    <!-- 弹出框 确认退出-->
    <div class="confirmBox flip-scale-2-hor-top" v-if="confirmBox">
      <div class="confirmBoxText">
        <h3 style="position: relative;top:10px;">是否要退出登陆？</h3>
        <div class="confirmBtnBox">
          <div class="btnLeft">
            <button class="button1" @click="cancel">取消</button>
          </div>
          <div class="btnRight">
            <button class="button2" @click="confirmLogout">确认</button>
          </div>
        </div>
        <div style="height: 100px;"></div>
      </div>

    </div>
  </div>
</template>
<script>
  import myHttp from '../utils/http'
  import Footer from "../components/Footer";
  import Header from "../components/Header";
  import NoOrder from "../components/NoOrder"
  import {EventBus} from '../utils/event-bus'
  export default {
    name: "Home",
    components: {Header, Footer,NoOrder},
    data:function(){
      return{
        courseList:[

        ],
        hotCourseList:[],
        courseList1:[],
        courseList2:[],
        courseList3:[],
        courseList4:[],
        isLoading:true,  //是否加载中
        isOrder: false,   //是否有订单 默认没有
        isMyOrder: true,  //是否是在我的课程项目中  //默认在我的课程这一菜单栏目下
        confirmBox:false,
        myUrl:'',
        isUpdateUrl:false
      }
    },
    beforeCreate() {

        this.isLoading =true;
    },
    created() {

    },
    mounted() {

      //查找课程
      this.findCourse();

      this.findMyCourse();
      //接受事件
      EventBus.$on('changeCourse',res =>{
        console.log('切换课程：');
        console.log(res);

        let _self =this;
        _self.courseList = [];
        console.log(_self.courseList);
        switch (res.course_id) {

          case '1':
            _self.courseList = _self.courseList1;
            _self.isMyOrder = true;   //在我的课程这一菜单栏目下
            break;
          case '2':
            _self.courseList = _self.hotCourseList;
            _self.isMyOrder = false;   //不在我的课程这一菜单栏目下
            break;
          case '3':
            _self.courseList = _self.courseList2;
            _self.isMyOrder = false;   //不在我的课程这一菜单栏目下
            break;
          case '4':
            _self.courseList = _self.courseList3;
            _self.isMyOrder = false;   //不在我的课程这一菜单栏目下
            break;
        }
      })
    },
    methods:{
      //进入课程详情页
      toCourse(index,course_id,course_num){

        // console.log('索引：'+index+'课程id：'+course_id);
        // console.log('%c '+course_num,'font-size:20px;');
        window.localStorage.setItem('course_num',course_num);
        this.$router.push({
          name:'Course',
          query:{
            index:index,
            course_id:course_id
          }
        });
      },
      //退出登陆
      logout(){
        this.confirmBox = true;
       // this.$router.push("/");
      },
      cancel(){
        this.confirmBox = false;
      },
      confirmLogout(){
        window.localStorage.setItem('token','');
        this.$router.push("/");
      },

      // 刷新页面
      refreshPages(){
       // window.location.reload(true);
       // this.$router.go(0);

      //  let url =window.location.href;
       //  let arr =url.split('#');
       // let tmpUrl = arr[0]+'/'+Math.floor(Math.random()*10+1)+'/#'+arr[1];
       // console.log(this.$router);

       //  window.location.href=url;

        this.$router.push('/refresh');
      },
      //查找课程
      findCourse(){

        myHttp.request({
          url: this.GLOBAL.serverURL+'api/app/courses/',
          method: 'get',
          params: {
            token:window.localStorage.getItem('token')
          }
        })
          .then(res=>{


            console.log(res.data);
            console.log('res.config.headers.token:'+res.config.headers.authorization);

            let token_temp = window.localStorage.getItem('token');
            if(token_temp == undefined){
              console.error('token丢失');
              window.localStorage.setItem('token',res.config.headers.authorization);
            }

            //  this.courseList=res.data;

            //将巧手智心课取出来
            for(var i=0;i<res.data.length;i++){

              //取出热门课程
              if(res.data[i].ishot==true){
                this.hotCourseList.push(res.data[i]);
              }

              if(res.data[i].category.name=='youxiao'){
                //衔接课程
                this.courseList3.push(res.data[i]);
              }else{
                this.courseList2.push(res.data[i]);
              }


            }
            //  this.courseList = this.hotCourseList;
            return res;
          }).catch(res =>{
          console.log('%c catch...','font-size:30px;color:red;');
          console.log(res);
        }).finally(res =>{
          // console.log('finally...'+res);

          console.log(this.hotCourseList);
          console.log(this.courseList3);
          console.log(this.courseList2);

          this.isLoading = false;
        })

      },

      //查找已购买课程
      findMyCourse(){
        myHttp.request({
          url:this.GLOBAL.serverURL+'api/V2/courselist',
          method:"Get",
          params:{
            userid: window.localStorage.getItem('id'),
            token:window.localStorage.getItem('token')
          },
        }).then( res =>{
          console.log('我的课程：');
          console.log(res);
          let token_temp = window.localStorage.getItem('token');
          if(token_temp == undefined){
            console.error('token丢失');
            window.localStorage.setItem('token',res.config.headers.authorization);
          }

          //判断是否购买课程
          if(res.data.length == 0){
          //  console.log('没有课程订单');
            //提示信息 没有课程订单
            this.isOrder =true;
          }else{
            this.isOrder =false;
          }


          this.courseList1 =res.data;
          this.courseList = this.courseList1;
        }).catch(err =>{
          console.log(err);
        }).finally(res =>{

        })
      },
    }
  }
</script>

<style scoped>

  @import "../assets/fonts/font.css";
  .box{
    margin-top: 4%;
    width: 100%;
    /*background-color: #fa84a1;*/
    padding: 5px;
    margin-bottom: 3%;
  }
  .imgCard{
    width: auto;
    /*height: 300px;*/
    /*background-color: aquamarine;*/
    padding: 5px;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 25px;
  }
  .imgCard .courseImg{
    max-width: 100%;
    /*max-height: 100%;*/
    border-radius: 10px;
    width: 1260px;
    height: 260px;

  }

  .confirmBox{
    position:fixed;
    top:30%;
    left:35%;
    width: 30%;
    /*height:30%;*/
    background-color: #fdff63;
    border-radius: 20px;
    background-image: url("../assets/box-bg3.jpg");
    background-size: 100% 100%;
    border: black 2px solid;
  }

  .confirmBoxText{
    position: relative;
    top: 10%;
    font-family: myMind;
    font-size: larger;

  }

  .confirmBtnBox{
    background-color: cadetblue;
    width: 70%;
    /*height: 50%;*/
    text-align: center;
    position: relative;
    left: 15%;
    top: 20px;
    /*display: flex;*/

  }

  .btnLeft{
    width: 50%;
    /*background-color: blueviolet;*/
    float: left;
  }
  .btnRight{
    width: 50%;
    /*background-color: cornflowerblue;*/
    float: right;
  }
  .button1{
    font-size: 0.8em;
    width: 80%;
    /*height: 18%;*/
    border-radius: 25px;
    font-family: myMind;
    outline: none;
    border-color: black;
    cursor: pointer;
    background-color: #f5efdf;
    line-height: 40px;
  }
  .button2{
    font-size: 0.8em;
    width: 80%;
    /*height: 18%;*/
    border-radius: 25px;
    font-family: myMind;
    outline: none;
    border-color: black;
    cursor: pointer;
    background-color: #eb7413;
    line-height: 40px;
    color: white;
  }

  .flip-scale-2-hor-top{-webkit-animation:flip-scale-2-hor-top .5s linear both;animation:flip-scale-2-hor-top .5s linear both}


  /* ----------------------------------------------
   * Generated by Animista on 2021-3-14 15:4:53
   * Licensed under FreeBSD License.
   * See http://animista.net/license for more info.
   * w: http://animista.net, t: @cssanimista
   * ---------------------------------------------- */

  /**
   * ----------------------------------------
   * animation flip-scale-2-hor-top
   * ----------------------------------------
   */
  @-webkit-keyframes flip-scale-2-hor-top {
    0% {
      -webkit-transform: translateY(0) rotateX(0) scale(1);
      transform: translateY(0) rotateX(0) scale(1);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
    50% {
      -webkit-transform: translateY(-50%) rotateX(-90deg) scale(2);
      transform: translateY(-50%) rotateX(-90deg) scale(2);
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
    }
    100% {
      -webkit-transform: translateY(-100%) rotateX(-180deg) scale(1);
      transform: translateY(-100%) rotateX(-180deg) scale(1);
      -webkit-transform-origin: 50% 100%;
      transform-origin: 50% 100%;
    }
  }
  @keyframes flip-scale-2-hor-top {
    0% {
      -webkit-transform: translateY(0) rotateX(0) scale(1);
      transform: translateY(0) rotateX(0) scale(1);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
    50% {
      -webkit-transform: translateY(-50%) rotateX(-90deg) scale(2);
      transform: translateY(-50%) rotateX(-90deg) scale(2);
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
    }
    100% {
      -webkit-transform: translateY(-100%) rotateX(-180deg) scale(1);
      transform: translateY(0) rotateX(0deg) scale(1);
      -webkit-transform-origin: 50% 100%;
      transform-origin: 50% 100%;
    }
  }




</style>



// WEBPACK FOOTER //
// src/views/Home.vue